// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"424":"cf85cb09","485":"42a75e3a"}[chunkId] + ".chunk.css";
};